import { formatDate } from '@clim/client-core';
import { Fragment, useState } from 'react';
import { ErrorBox, Input } from '../../components/ui';
import { useApi } from './common';

interface AuditRow {
  id: string;
  occurredAt: string;
  actorType: string;
  actorName: string | null;
  action: string;
  entityType: string | null;
  entityId: string | null;
  before: unknown;
  after: unknown;
  metadata: Record<string, unknown>;
  ip: string | null;
}

export function AuditAdmin() {
  const [action, setAction] = useState('');
  const { data, error } = useApi<AuditRow[]>(`/v1/admin/audit?limit=100${action ? `&action=${encodeURIComponent(action)}` : ''}`);
  const [open, setOpen] = useState<string | null>(null);
  return (
    <div>
      <Input placeholder="Filtrer par action (ex. dossier.status_changed)" value={action} onChange={(e) => setAction(e.target.value.trim())} />
      <ErrorBox message={error} />
      <table className="table compact">
        <thead>
          <tr>
            <th>Date</th>
            <th>Auteur</th>
            <th>Action</th>
            <th>Objet</th>
          </tr>
        </thead>
        <tbody>
          {data?.map((e) => (
            <Fragment key={e.id}>
              <tr onClick={() => setOpen(open === e.id ? null : e.id)} className="clickable">
                <td className="nowrap">{formatDate(e.occurredAt)}</td>
                <td>{e.actorName ?? e.actorType}</td>
                <td>{e.action}</td>
                <td className="muted">{e.entityType}</td>
              </tr>
              {open === e.id && (
                <tr>
                  <td colSpan={4}>
                    <pre className="json">{JSON.stringify({ before: e.before, after: e.after, metadata: e.metadata, ip: e.ip }, null, 2)}</pre>
                  </td>
                </tr>
              )}
            </Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
}
